var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"product-intro"}},[_c('product-intro-index'),_c('course-intro'),_c('course-iter'),_c('exam-intro'),_c('oj-intro')],1)}
var staticRenderFns = []

export { render, staticRenderFns }